import * as moment from 'moment';

export class PushNotification {
    id: number;
    type: number;
    timestamp: moment.Moment;
    text: string;

    constructor(obj: any) {
        this.id =           obj.order        || null;
        Object.assign(this, obj);
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/shared/models/push-notification.ts